const $btnExpand = $('.js-btn-expand');
const $win = $(window);

$btnExpand.on('click', function(event) {
  event.preventDefault();

  const $this = $(this);
  const element = $this.attr('href');

  if (!$this.is('a') && $win.width() < 768) {
    $this.toggleClass('is-active');
    $this
      .next()
      .stop()
      .slideToggle();

    return;
  }

  if (!$(element).length) {
    return;
  }

  $(element).toggleClass('is-expanded');
  $this.add(`a[href='${element}']`).toggleClass('is-active');

  if ($(element).hasClass('js-toggle')) {
    $(element)
      .stop()
      .slideToggle();
  }
});

$win.on('load resize', function() {
  $('.list-links').removeAttr('style');
});



// WEBPACK FOOTER //
// ./../src/assets/js/expand-elements.js